import PropTypes from 'prop-types';
import React from 'react';

class StatusInput extends React.Component {

  static propTypes = {
    componentParam: PropTypes.string.isRequired,
    groupOr3pc: PropTypes.bool.isRequired,
    shouldReset: PropTypes.bool.isRequired,
    updateStatus: PropTypes.string.isRequired,
  };


  _getStatusValue () {
    // If its a group or 3PC, and we're disabling the component, send null and use derived
    if (this.props.groupOr3pc && this.props.shouldReset) {
      return '';
    }
    return this.props.updateStatus;
  }

  render () {
    const name = `components[${this.props.componentParam}]`;
    return <input type="hidden" value={this._getStatusValue()} name={name} />;
  }
}

module.exports = StatusInput;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/components/status_input.jsx